import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAdmin, RequireAuth, RequireMember } from "@/components/Guards";
import MemberShell from "@/components/layout/MemberShell";
import Home from "@/pages/Home";
import Apply from "@/pages/Apply";
import SignIn from "@/pages/SignIn";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import OwnerSetup from "@/pages/OwnerSetup";
import Status from "@/pages/Status";
import Welcome from "@/pages/Welcome";
import Discover from "@/pages/Discover";
import ExperienceDetail from "@/pages/ExperienceDetail";
import ExperienceForm from "@/pages/ExperienceForm";
import Plan from "@/pages/Plan";
import Circle from "@/pages/Circle";
import Connect from "@/pages/Connect";
import Call from "@/pages/Call";
import MemberProfile from "@/pages/MemberProfile";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Legal, { NotFound } from "@/pages/Legal";
import { CookieBanner } from "@/components/CookieConsent";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/owner-setup" element={<OwnerSetup />} />
          <Route path="/status" element={<RequireAuth><Status /></RequireAuth>} />
          <Route path="/welcome" element={<RequireAuth><Welcome /></RequireAuth>} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/contact" element={<Legal page="contact" />} />
          <Route element={<RequireMember><MemberShell /></RequireMember>}>
            <Route path="/discover" element={<Discover />} />
            <Route path="/experiences/new" element={<ExperienceForm />} />
            <Route path="/experiences/:id" element={<ExperienceDetail />} />
            <Route path="/experiences/:id/edit" element={<ExperienceForm />} />
            <Route path="/experiences/:id/plan" element={<Plan />} />
            <Route path="/circle" element={<Circle />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/call/:id" element={<Call />} />
            <Route path="/members/:id" element={<MemberProfile />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:threadId" element={<Messages />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" offset={96} toastOptions={{ style: { background: "#101A17", border: "1px solid #233a33", color: "#F3F4EC" } }} />
    </AuthProvider>
  );
}

export default App;
